;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.product-pack.list')
    .controller('ProductPackListController', ProductPackListController)

  ProductPackListController.$inject = [
    // Angular
    '$state',

    // Managers
    'ProductPackManager',

    // Services
    'SnackService', 'DisplayService', 'FilterService',

    // Resolve
    'pagination'
  ]

  function ProductPackListController (
    $state,
    ProductPackManager,
    SnackService, DisplayService, FilterService,
    pagination
  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        pagination: pagination,

        getList: getList,
        go: go,
        deleteProductPack: deleteProductPack,
        addCriteria: addCriteria,
        clearSearch: clearSearch,
        sort: sort
      })

      init()
    }

    function init () {
      self.pagination.search = self.pagination.search || {}
      getList()
    }

    function getList () {
      self.loading = true
      self.pagination.orderBy = self.pagination.orderBy || 'label'

      self.pagination.search = FilterService.sanitizeSearchTree(self.pagination.search)

      var hasArchived = self.pagination.search && FilterService.hasArchivedCriteria(self.pagination.search)
      if (!hasArchived) {
        addCriteria('isArchived', { _id: 'archived', value: 'false' })
        return
      }

      self.pagination.save()

      var query = ProductPackManager
        .query()
        .fields('label products')
        .paginate(self.pagination.toQueryOptions())

      if (self.pagination.search && !angular.equals({}, self.pagination.search)) {
        query.setQuery(FilterService.parseQueryTree(self.pagination.search))
      }

      ProductPackManager.post(query).then(function (data) {
        self.productPacks = data.data
        self.pagination.totalElements = data.meta.total
        self.pagination.save()
        self.loading = false

        if (data.meta.total > 0 && !self.productPacks.length && self.pagination.currentPage >= 0) {
          self.pagination.currentPage = 0
          getList()
        }
      })
    }

    function go (productPack) {
      $state.go('product-pack.show', { id: productPack._id })
    }

    function deleteProductPack (productPack, $event) {
      $event.stopImmediatePropagation()
      DisplayService.confirmDeletion().then(function () {
        productPack.archive().then(function () {
          SnackService.snack({
            text: 'Pack produits supprimé !',
            delay: 5000
          })
          getList()
        })
      })
    }

    function addCriteria (key, value) {
      if (value !== undefined && value !== null) {
        self.pagination.search = FilterService.addCriteria(self.pagination.search, key, value)
        getList()
      }
    }

    function clearSearch () {
      self.pagination.search = {}
      getList()
    }

    function sort (name) {
      self.reverse = (self.pagination.orderBy === name) ? !self.reverse : false
      self.pagination.orderBy = name
      self.pagination.reverse = self.reverse
      getList()
    }
  }
})(window.angular, window._)
